import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionSeven: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">7. Welche Sorte hast Du gekauft?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>TREK Biscoff Protein Oat Bar</>} className=" pb-2 text-green">
					<input type="radio" {...register("question7")} name="question7" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question7 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>TREK Cocoa Protein Protein Bar</>} className=" pb-2 text-green">
					<input type="radio" {...register("question7")} name="question7" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question7 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Weiß ich nicht mehr</>} className=" pb-2 text-green">
					<input type="radio" {...register("question7")} name="question7" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question7 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionSeven
